import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHead } from "@/components/storefront/common";
import { resolveMediaUrl, handleMediaError } from "@/lib/media";

export default function Categories() {
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/categories").then(({ data }) => setCats(data.categories)); }, []);
  return (
    <div className="container-x py-8">
      <PageHead title="Shop by Category" crumbs={[{ label: "Home", to: "/" }, { label: "Categories" }]} />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
        {cats.map((c) => (
          <Link key={c.id} to={`/category/${c.slug}`} data-testid={`category-card-${c.slug}`}
            className="group rounded-xl border border-slate-200 overflow-hidden bg-white hover:shadow-lg transition">
            <div className="aspect-[4/3] bg-slate-50 overflow-hidden">
              <img src={resolveMediaUrl(c.image)} alt={c.name} loading="lazy" onError={handleMediaError} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-4">
              <h3 className="font-semibold text-slate-900">{c.name}</h3>
              <p className="text-xs text-slate-500 mt-0.5 line-clamp-1">{c.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
